<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="7">
        <b-form-group>
          <CoolSelect
            v-if= "isCurrent"
            v-model="territoryToLoad"
            class="form-input dropdown-content"
            placeholder="New Territory"
            theme="bootstrap"
            tooltip="Territory"
            :items="territoryList"
            item-text="TerritoryName"
            item-value="TerritoryID"
            id="TerritoryID"
            @select="setTerritoryEdit"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth"
                  >Territory</b-input-group-text
                >
              </b-input-group-prepend>
            </template>
            <!-- <template slot="item" slot-scope="{ item }">
                    <div class="item">
                      <img :src="item.thumbnail" class="logo" />
                      <span class="item-name">{{ item.CommonName }}</span>
                    </div>
            </template>-->
          </CoolSelect>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth"
                >Radius</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-input
              v-model="territory.territory_edit.DefaultRadius"
              placeholder="Radius"
              autocomplete="off"
              type="text"
              id="DefaultRadius"
              v-mask="'###'"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="1" >
              <span class="icon-small">
               <i
                  class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
                  style="color: #555;" 
                  @click="my_download"
                ></i>
                </span>
            </b-col>
    </b-row>
    <b-row>
      <b-col lg="9">
        <TerritoryMap />
      </b-col>
       <b-col sm="3">
<b-row  v-if="QueryByZip.length == 5"
      class="primary-row divider-row-thin"
    >
      <b-col sm="12"><h4 class="text-center">Details</h4></b-col>
    </b-row>
<b-row>
      <b-col sm="12">
        <ZipCard  v-if="QueryByZip.length == 5" /> 
      </b-col>
    </b-row>
        <b-row
      v-if="QueryByZip.length == 5"
      class="primary2-row divider-row-thin"
    >
      <b-col sm="12">
        <h4 class="text-center">Usage</h4>
        </b-col>
    </b-row>
    <b-row  v-if="QueryByZip.length == 5 && !zip.zip_usage_map.length">
      <b-col sm="12"><h4 class="text-center">None</h4></b-col>
    </b-row>
    <b-row  v-if="QueryByZip.length == 5  && zip.zip_usage_map.length">
      <b-col sm="12">
        <b-table
          :items="zip.zip_usage_map"
          :fields="fields2"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
        ></b-table>
        </b-col>
    </b-row>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col lg="12">
        <b-table
          :items="Zips"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="1"
          :per-page="1000"
        />
      </b-col>
    </b-row>-->
  </div>
</template>

<script>
import TerritoryMap from "@/components/maps/TerritoryMap.vue";
import { mapState } from "vuex";
import ZipCard from "@/components/cards/ZipCard.vue";
import cTable from "@/views/base/Table.vue";
import { CoolSelect } from "vue-cool-select";

export default {
  components: {
    TerritoryMap,
    cTable,
    CoolSelect,
    ZipCard
  },
  computed: {
    ...mapState(["territory", "zip", "n_user"]),
  },
  data: () => {
    return {
      QueryByZip: "",
      territoryToLoad: -99,
      territoryList: [],
      isCurrent: true,
      fields2: [
        {
          key: "TerritoryName",
          label: "Territory",
          sortable: true,
        },
        {
          key: "DateOfSeating",
          label: "Date",
          sortable: true,
        },
        {
          key: "Restaurant",
          label: "Restaurant",
          sortable: true,
        },
      ],
      fields: [ 
        {
          key: "TerritoryName",
          label: "Territory",
          sortable: true,
        },
        {
          key: "Zip",
          label: "Zip",
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.territoryList = this.$store.state.territory.territories;
    if (this.$store.state.territory.territory_edit) {
      this.territoryToLoad = this.$store.state.territory.territory_edit.TerritoryID;
    }
  },
  mounted() {
  },

  methods: {
    setTerritoryEdit() {
      this.$store.dispatch("territory/loadTerritoryEdit", this.territoryToLoad);
    },
    my_download() {
this.$store
        .dispatch("territory/DownloadTerritoryZips", this.$store.state.territory.territory_edit)
        .then(response => (
          window.open("http://rm_api.revolutionterritorymanager.com/Output/" + response.data["ExportZipsResult"], "_blank") 
        )
        );
    },
  },
  watch: {
     QueryByZip: function (newValue, oldValue) {
      if (newValue.length === 5) {
        this.$store.dispatch("globals/setQueryByZip", newValue);
        this.refreshWait;
        this.$store.dispatch("zip/getUsageMap", newValue);
      }
    },
    "$store.state.territory.territory_edit.TerritoryID": function (newValue) {
    },
    "$store.state.globals.query_by_zip": function (newValue) {
      if (newValue.length === 5) {
        this.QueryByZip = newValue;
        this.$store.dispatch("globals/setQueryByZipObject", newValue);
      }
    },
    "$store.state.territory.territories.length": function (newValue) {
      this.territoryList = this.$store.state.territory.territories;
      if (this.$store.state.territory.territory_edit) {
      this.territoryToLoad = this.$store.state.territory.territory_edit.TerritoryID;
    }
    },
  },
};
</script>

<style lang="scss" scoped></style>
